var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #02025b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.909449,48.237543c6.753581,12.411075,10.590549,26.638673,10.590551,41.762443.000008,48.324916-39.17507,87.500006-87.499986,87.500014-48.324916.000008-87.500006-39.17507-87.500014-87.499986S41.67507,2.500008,89.999986,2.5c24.986317-.000004,47.526529,10.473019,63.47033,27.268764l-68.965878,68.911549-27.050477-24.934275-14.961029,17.081867,42.512532,39.091971,81.903986-81.682333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconNew);
export default __webpack_public_path__ + "static/media/recon_new.3f81bd9f1267141d1b9a9ae9f1904b8f.svg";
export { ForwardRef as ReactComponent };